import PropTypes from 'prop-types';
import { accountShape } from 'Workspace/types/account';
import { teamSummaryShape } from 'Workspace/types/team';

const collaboratorShape = PropTypes.shape({
  permissionLevel: PropTypes.string,
  account: accountShape,
  team: teamSummaryShape,
});

const collaboratorSummaryShape = PropTypes.shape({
  teams: PropTypes.arrayOf(collaboratorShape),
  accounts: PropTypes.arrayOf(collaboratorShape),
});

export {
  collaboratorShape,
  collaboratorSummaryShape,
};
